import { useMemo } from "react";

import {
  TableControlLayoutProps,
  TableControlStateDefaults,
} from "./TableControlLayoutProps";
import { extractAndMergeOptions } from "./utils/extractAndMergeOptions";

export const TABLE_CONTROL_STATE_DEFAULTS: TableControlStateDefaults = {
  pageSize: 10,
  density: "compact",
};

export function useTableControlStateDefaults(
  options: TableControlLayoutProps,
): Required<TableControlStateDefaults> {
  return useMemo(
    () => extractAndMergeOptions(options, TABLE_CONTROL_STATE_DEFAULTS),
    [options],
  );
}
